import { __rest } from "tslib";
import React from 'react';
import { Checkbox } from '../../Checkbox';
import { Header } from './Header';
export function SelectionHeader(_a) {
    var { selected, indeterminate, onChange, selectionMode } = _a, headerProps = __rest(_a, ["selected", "indeterminate", "onChange", "selectionMode"]);
    if (selectionMode === 'single')
        return React.createElement(Header, Object.assign({}, headerProps));
    return (React.createElement(Header, Object.assign({}, headerProps),
        React.createElement(Checkbox, { checked: selected, indeterminate: indeterminate, onChange: onChange })));
}
//# sourceMappingURL=SelectionHeader.js.map